// O7 · Who do you want to work beside? (QO7_Pick): 2x2 portrait cards, BEST MATCH from the first tone pick,
// ALSO GOOD from the second tone pick (or the next in ALSO_ORDER). Picking -> progress 88 -> O8 with that buddy.
import { useEffect, useRef, useState } from 'preact/hooks';
import type { CharId } from '@shared/types';
import { CHAR_IDS } from '@shared/types';
import { ALSO_ORDER, BEST_BY_TONE, C, bestMatch } from '@shared/content/characters';
import { Screen, OnbTopBar, ScrollArea } from '../../components';
import { back, go } from '../../router';
import { draftStore, progress, setDraft, useDraft } from './draft';
import s from './O7Pick.module.css';

export function matchFor(tone: string[]): { best: CharId; also: CharId } {
  const { best, also } = bestMatch(tone);
  const second = tone[1] && BEST_BY_TONE[tone[1]];
  return { best, also: second && second !== best ? second : also || ALSO_ORDER[0] };
}

export function O7Pick() {
  const tone = useDraft((d) => d.ob.tone);
  const { best, also } = matchFor(tone);
  const [picked, setPicked] = useState<CharId | null>(null);
  const tm = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => () => { if (tm.current) clearTimeout(tm.current); }, []);

  const pick = (ch: CharId) => {
    if (picked) return;
    setPicked(ch);
    tm.current = setTimeout(() => {
      // A different buddy starts O8 fresh (their lines differ).
      if (draftStore.get().ch !== ch) setDraft({ ch, said: null, fh: null, fixes: [], smaller: false, cant: false, reason: null, fh2: null, laterIdx: 0, workCard: null, evenSmaller: null, first: null });
      go('O8');
    }, 450);
  };

  return (
    <Screen theme="pre" bg="#100E0C" id="O7">
      <OnbTopBar pct={progress('O7', !!picked)} onBack={() => back('O6')} />
      <div class={s.head}>
        <h1 class={s.h1}>Who do you want to work beside?</h1>
        <p class={s.sub}>{`Based on what you said, ${C[best].name} fits you best. Pick anyone. You can switch later.`}</p>
      </div>
      <ScrollArea class={s.grid} style={{ display: 'grid' }} fadeTop={16}>
        {CHAR_IDS.map((ch) => {
          const c = C[ch];
          const isBest = ch === best, isAlso = ch === also && !isBest, on = picked === ch;
          return (
            <button
              key={ch} type="button" class={s.card} data-on={on ? 'true' : 'false'} data-best={isBest ? 'true' : 'false'}
              style={{ '--c-acc': c.acc } as Record<string, string>}
              aria-label={`${c.name}${isBest ? ', best match' : isAlso ? ', also good' : ''}. ${c.pickLine}`}
              onClick={() => pick(ch)}
            >
              <img src={c.assets.key} alt="" draggable={false} class={s.img} />
              {(isBest || isAlso) && <span class={s.badge} data-best={isBest ? 'true' : 'false'}>{isBest ? 'BEST MATCH' : 'ALSO GOOD'}</span>}
              <span class={s.info}>
                <span class={s.name}>{c.name}</span>
                <span class={s.line}>{c.pickLine}</span>
              </span>
            </button>
          );
        })}
      </ScrollArea>
      <p class={s.footer}>All four are AI characters. For adults 18+.</p>
    </Screen>
  );
}
